const ROLE_VIEWER = 'viewer'
const ROLE_TEAM = 'team'
const ROLE_ISTAR_DIVISION = 'istar_division'
const ROLE_ISTAR_BRIGADE = 'istar_brigade'
const ROLE_BRIGADE_VIEWER = 'brigade_viewer'
const ROLE_ISTAR_ZONE = 'istar_zone'
const ROLE_OTG_COORDINATOR = 'otg_coordinator'
const ROLE_OSG_COORDINATOR = 'osg_coordinator'
const ROLE_EW_OPERATOR = 'ew_operator'
const ROLE_UAV_DISPATCHER = 'uav_dispatcher'
const ROLE_UAV_DISPATCHER_OTG = 'uav_dispatcher_otg'
const ROLE_UAV_VIEWER_OTG = 'uav_viewer_otg'
const ROLE_UAV_CREW = 'uav_crew'
const ROLE_ADMIN = 'admin'

const Roles = {
    VIEWER: {
        value: 'viewer',
        title: 'Viewer',
        defaultPage: '/history',
        available: true,
        onlyAdminCreate: false,
        visibleFor: <string[]>[
            ROLE_VIEWER,
            ROLE_ISTAR_DIVISION,
            ROLE_ISTAR_BRIGADE,
            ROLE_BRIGADE_VIEWER,
            ROLE_ISTAR_ZONE,
            ROLE_OTG_COORDINATOR,
            ROLE_ADMIN,
        ],
    },
    TEAM: {
        value: 'team',
        title: 'Team',
        defaultPage: '/fly',
        available: true,
        onlyAdminCreate: false,
        visibleFor: <string[]>[
            ROLE_VIEWER,
            ROLE_ISTAR_DIVISION,
            ROLE_ISTAR_BRIGADE,
            ROLE_BRIGADE_VIEWER,
            ROLE_ISTAR_ZONE,
            ROLE_OTG_COORDINATOR,
            ROLE_ADMIN,
        ],
    },
    ISTAR_DIVISION: {
        value: 'istar_division',
        title: 'ISTAR division',
        defaultPage: '/fly',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ISTAR_BRIGADE,
            ROLE_BRIGADE_VIEWER,
            ROLE_ISTAR_ZONE,
            ROLE_OTG_COORDINATOR,
            ROLE_ADMIN,
        ],
    },
    ISTAR_BRIGADE: {
        value: 'istar_brigade',
        title: 'ISTAR Brigade',
        defaultPage: '/admin/divisions',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ADMIN,
        ],
    },
    BRIGADE_VIEWER: {
        value: 'brigade_viewer',
        title: 'Brigade Viewer',
        defaultPage: '/admin/divisions',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ADMIN,
        ],
    },
    ISTAR_ZONE: {
        value: 'istar_zone',
        title: 'ISTAR zone',
        defaultPage: '/zone-admin/active',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_OTG_COORDINATOR,
            ROLE_ADMIN,
        ],
    },
    OTG_COORDINATOR: {
        value: 'otg_coordinator',
        title: 'Corps Coordinator',
        defaultPage: '/zone-admin/active',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ADMIN,
        ],
    },
    OSG_COORDINATOR: {
        value: 'osg_coordinator',
        title: 'OSG Coordinator',
        defaultPage: '/fly',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ADMIN,
        ],
    },
    EW_OPERATOR: {
        value: 'ew_operator',
        title: 'Оператор РЕБ',
        defaultPage: '/ew-status',
        available: true,
        onlyAdminCreate: false,
        visibleFor: <string[]>[
            ROLE_OTG_COORDINATOR,
            ROLE_ADMIN,
        ],
    },
    UAV_DISPATCHER: {
        value: 'uav_dispatcher',
        title: 'Диспетчер UAV',
        defaultPage: '/uav-dispatch',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ADMIN,
        ],
    },
    // Той самий контур диспетчерської, що UAV_DISPATCHER, але зі скоупом по корпусу
    // (маршрут заявки перетинає otgs.polygon користувача) замість усього фронту.
    UAV_DISPATCHER_OTG: {
        value: 'uav_dispatcher_otg',
        title: 'Диспетчер корпуса UAV',
        defaultPage: '/uav-dispatch',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ADMIN,
        ],
    },
    // Той самий скоуп, що UAV_DISPATCHER_OTG, але без права редагування (без uav_missions:manage).
    UAV_VIEWER_OTG: {
        value: 'uav_viewer_otg',
        title: 'Переглядач корпуса UAV',
        defaultPage: '/uav-dispatch',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ADMIN,
        ],
    },
    // Член екіпажу БпЛА. Заводить його командир підрозділу — саме він потім формує з таких
    // юзерів екіпаж в адмінці, тому роль видима на рівні підрозділу, а не лише адміну.
    UAV_CREW: {
        value: 'uav_crew',
        title: 'Екіпаж БпЛА',
        defaultPage: '/uav-flight',
        available: true,
        onlyAdminCreate: false,
        visibleFor: <string[]>[
            ROLE_ISTAR_DIVISION,
            ROLE_ISTAR_BRIGADE,
            ROLE_BRIGADE_VIEWER,
            ROLE_ISTAR_ZONE,
            ROLE_OTG_COORDINATOR,
            ROLE_UAV_DISPATCHER,
            ROLE_ADMIN,
        ],
    },
    ADMIN: {
        value: 'admin',
        title: 'Admin',
        defaultPage: '/fly',
        available: true,
        onlyAdminCreate: true,
        visibleFor: <string[]>[
            ROLE_ADMIN,
        ],
    },
}

export default Roles

// Ролі, чий скоуп визначається ПІДРОЗДІЛОМ користувача: для них поле «Підрозділ» у формі
// обов'язкове й видиме. Дзеркало acl.DivisionScopedRoles на бекенді — там без підрозділу
// ACL просто не може нічого порахувати.
export const DIVISION_SCOPED_ROLES: string[] = [
    ROLE_VIEWER,
    ROLE_TEAM,
    ROLE_ISTAR_DIVISION,
    ROLE_UAV_CREW,
]

// Ролі, що працюють з бойовими чергуваннями, — дзеркало списку ролей на маршруті
// GET /api/sessions (backend/routes/router_list.go). Список саме ПОЗИТИВНИЙ: нова роль,
// додана колись поруч, за замовчуванням опиниться поза ним і мовчки не смикатиме ендпоінт,
// на який у неї немає доступу. Негативний список дав би протилежне — 403 на кожній сторінці.
export const SESSION_AWARE_ROLES: string[] = [
    ROLE_ADMIN,
    ROLE_ISTAR_DIVISION,
    ROLE_ISTAR_ZONE,
    ROLE_TEAM,
    ROLE_OTG_COORDINATOR,
    ROLE_OSG_COORDINATOR,
    ROLE_EW_OPERATOR,
    ROLE_ISTAR_BRIGADE,
    ROLE_BRIGADE_VIEWER,
]

// Ролі, чий скоуп визначається КОРПУСОМ користувача: для них поле «Корпус» у формі
// обов'язкове й видиме. Дзеркало acl.OtgScopedRoles на бекенді.
export const OTG_SCOPED_ROLES: string[] = [
    ROLE_OTG_COORDINATOR,
    ROLE_EW_OPERATOR,
    ROLE_UAV_DISPATCHER_OTG,
    ROLE_UAV_VIEWER_OTG,
]

// Корпусні ролі, яким дозволено ОДРАЗУ КІЛЬКА корпусів: у формі поле стає множинним.
// Дзеркало acl.MultiOtgScopedRoles на бекенді — решта корпусних ролей лишається з одним
// корпусом (зони, черги на частоти, адміністрування вертикалі).
export const MULTI_OTG_SCOPED_ROLES: string[] = [
    ROLE_UAV_VIEWER_OTG,
]

// Ролі, яким map:view видано ВУЗЬКО — лише заради лінії фронту на власній мапі напрямку
// (диспетчерська БпЛА, сторінка вильоту екіпажу). Окрема загальна сторінка «Мапа» їм
// не потрібна, тому в навігації вона для них схована.
export const ROLES_WITHOUT_GENERAL_MAP: string[] = [
    ROLE_UAV_DISPATCHER,
    ROLE_UAV_DISPATCHER_OTG,
    ROLE_UAV_VIEWER_OTG,
    ROLE_UAV_CREW,
]

export function getDefaultPageForRole(roleValue: string | undefined): string {
    if (!roleValue) return '/fly'
    const role = Object.values(Roles).find(r => r.value === roleValue)
    return role?.defaultPage || '/fly'
}
